export enum HomeOwnerStatusEnum {
    Selling = 1,
    Sold = 2,
    RemovingNameFromMortgage = 3,
    RemovedNameFromMortgage = 4,
}
